<script lang="ts" setup>
import { BaseballStatId } from '@collector/sportsapi-client-legacy'

import BaseRunnersStat from './BaseRunnersStat.vue'
</script>

<template>
  <div
    class="bg-neutral-light-7 mt-6 flex h-12.5 justify-center gap-x-2 rounded-lg p-2"
  >
    <BaseRunnersStat
      label="B"
      :statId="BaseballStatId.BallsTemporary"
    />
    <BaseRunnersStat
      label="S"
      :statId="BaseballStatId.StrikesTemporary"
    />
    <BaseRunnersStat
      label="O"
      :statId="BaseballStatId.OutsTemporary"
    />
  </div>
</template>
